ALLOWED_CONTROLLER = 'kiosks'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  table = $('#kiosks').DataTable
    dom: '<"fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix ui-corner-tl ui-corner-tr"lBfr>'+
      't'+
      '<"fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix ui-corner-bl ui-corner-br"ip>'
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    search: true
    buttons: [
      {
        text: 'Show all',
        action: ->
          searchColumns()
      }
    ]
    sAjaxSource: $('#kiosks').data('source')
    aoColumnDefs: [ { 'bSortable': false, 'aTargets': [ 1, 2, 3, 4, 5, 6 ] } ]
    lengthMenu: [ 10, 25, 50, 75, 100, 500 ]

  searchColumns = ->
    $.ajax
      type: 'GET',
      url: '/kiosks'
      complete: ->
        table.search('show all').draw()

$(document).ready(ready)
